module.exports = __webpack_public_path__ + "img/speedometer.552456d0.svg";